module.exports = __webpack_public_path__ + "files/fa47acb01f8b804865356502075578d5.png";